import { ConfigService } from './../../base-services/config.service';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../base-services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    constructor(private authentication: AuthenticationService, private router: Router,
        private activatedRoute: ActivatedRoute,
        private configService: ConfigService) { }

    logging: boolean = false;

    ngOnInit() {
    }

    login(username, password) {
        this.logging = true;
        this.authentication.Login(username, password)
            .subscribe(data => {
                this.activatedRoute.queryParams.subscribe( queryParameters => {
                    //this.configService.SelectedOrgJed
                        //.subscribe(selectedOrgJed => {
                            //if(selectedOrgJed && selectedOrgJed.ID != null)
                                //this.authentication.ChangeOrgJed(selectedOrgJed)
                                    //.subscribe(() => {
                                        //this.router.navigate(['/']);
                                    //})
                                //else
                                    this.router.navigate(['company-selector'], { queryParams: queryParameters});
                    //this.router.navigate([this.activatedRoute.queryParams != null && queryParameters.returnUrl != null ? queryParameters.returnUrl : '']);
                        //})
            })
        });
    }

}
